export const microbiomeVideo = {
  type: 'video',
  devPlaybackId: '6Z02R016zJ8VbZNridGTzV9ylf02ttaS79MAmV9aT3OtLk',
  mobileDevPlaybackId: 'RFXOFtkg01hHzL4dNrudCPoPr84Xol00PgJnLOjoUuWqM',
  playbackId: 'lghhNZvdjkKNBiuV2g1GIWP9hBYnAYYQrd83swVFayM',
  mobilePlaybackId: 'oMCpXSzvLPcYg8jZeStvs9LUXPFb37BDmjjjkMRgH900',
};

// Shown in place of the intro preview video under reduced motion.
export const microbiomeIntroStill = {
  src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto,w_1400/v1793381841/library/microbiome/microbiome-101-cover.png',
};

export const microbiomeImageSlide = {
  type: 'image',
  src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1750392786/library/microbiome/microbiome-fpo-2.jpg',
  heading: 'Science-backed probiotics for your whole body of health.',
  title: 'Whole Body Health',
  chapter: 5,
  description:
    'From gut to brain to skin health, your microbiome plays a key role in how you feel every day. Seed’s science-backed probiotics are designed to support your body where it’s needed most.',
};

export const microbiomeChapters = [
  {
    type: 'video',
    title: 'The Microbiome',
    chapter: 1,
    startTime: 0,
    duration: 16.5,
  },
  {
    type: 'video',
    title: 'The Gut Microbiome',
    chapter: 2,
    startTime: 16.5,
    duration: 24,
  },
  {
    type: 'video',
    title: 'The Probiotics',
    chapter: 3,
    startTime: 40.89,
    duration: 50,
  },
  {
    type: 'video',
    title: 'DS-01 Daily Synbiotic',
    chapter: 4,
    startTime: 91.88,
    duration: 41,
  },
];
